import React from "react";
import { Box } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useFormContext, useWatch } from "react-hook-form";

import { EstimationColumns } from "./columnNames/NozzleColumns";

import {
  compactTableProps,
  greyTable,
} from "../../../../../../styles/muiProps";

import {
  useResponsivePvTable,
  getResponsivePvTableProps,
} from "./responsivePvTable";

/**
 * Relative widths for the estimation columns.
 */
const ESTIMATION_COLUMN_WEIGHTS = {
  "Flange Weight": 1,
  "Pipe Weight": 1,
  "Pad Weight": 1,

  "Nozzle Weld Hours": 1.05,
  "Pipe Weld Hours": 1,
  "Pad Weld Hours": 1,

  "Bolt-up Hours": 0.95,
  "NDT Cost": 0.95,
};

export const EstimationTable = (props) => {
  const { isLoading, isError } = props;

  const { control } = useFormContext();

  const watchedRows = useWatch({
    control,
    name: "DataGridView2",
  });

  const {
    viewportRef,
    tableWidth,
    headerFontSize,
    bodyFontSize,
    columns: responsiveColumns,
  } = useResponsivePvTable(EstimationColumns ?? [], ESTIMATION_COLUMN_WEIGHTS);

  const responsiveTableProps = getResponsivePvTableProps({
    tableWidth,
    headerFontSize,
    bodyFontSize,
  });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        boxSizing: "border-box",

        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <MaterialReactTable
        /*
         * Existing shared styling first.
         */
        {...compactTableProps}
        {...greyTable}
        /*
         * Responsive layout overrides shared fixed sizing.
         */
        {...responsiveTableProps}
        /*
         * Keep these after all spread props.
         */
        columns={responsiveColumns ?? []}
        data={watchedRows ?? []}
        enableEditing
        enableTopToolbar={false}
        editDisplayMode="cell"
        enableSorting={false}
        enableColumnActions={false}
        muiEditTextFieldProps={{
          fullWidth: true,

          sx: {
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",

            overflow: "hidden",

            "& .MuiInputBase-root": {
              width: "100%",
              minWidth: "0 !important",
              maxWidth: "100%",

              overflow: "hidden",
            },

            "& .MuiInputBase-input": {
              width: "100%",
              minWidth: "0 !important",
              maxWidth: "100%",

              boxSizing: "border-box",

              padding: {
                xs: "2px 0",
                sm: "3px 1px",
                md: "4px 2px",
              },

              textAlign: "center",

              fontSize: `${bodyFontSize}px !important`,
            },
          },
        }}
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Estimation failed. Please check Input Data",
              }
            : undefined
        }
        state={{
          isLoading,
          showAlertBanner: isError,
        }}
      />
    </Box>
  );
};
